import { Box, Grid, Stack, Typography } from "@mui/material";
import Skills from "./skills";
import Hello from "./hello";
import { motion } from "framer-motion";
import BgText from "./bgText";

import FloatingCube from "./FloatingCube";

const About = () => {
    return (
        <Stack
            sx={{
                width: "100%",
                minHeight: "100vh",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                zIndex: 2,
                overflow: 'hidden'
            }}
            id="about"
        >
            {/* 3D Interactive Cubes */}
            <FloatingCube size={200} color="rgba(34, 211, 238, 0.15)" initialPos={{ top: '15%', right: '10%' }} />
            <FloatingCube size={120} color="rgba(129, 140, 248, 0.2)" initialPos={{ bottom: '15%', left: '5%' }} />
            
            <Box
                sx={{
                    position: "absolute",
                    top: 40,
                    width: "90%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    zIndex: 10
                }}
            >
                <Typography
                    variant="h5"
                    fontWeight={700}
                    sx={{ color: "white", letterSpacing: '-0.05em' }}
                >
                    DO.
                </Typography>
                <Stack direction="row" spacing={4}>
                    {['About', 'Projects', 'Contact'].map((item) => (
                        <Typography
                            key={item}
                            variant="body2"
                            sx={{ 
                                color: "rgba(255, 255, 255, 0.5)", 
                                cursor: "pointer",
                                transition: 'color 0.3s ease',
                                '&:hover': { color: 'white' }
                            }}
                        >
                            {item}
                        </Typography>
                    ))}
                </Stack>
            </Box>

            <Grid container sx={{ width: "85%", maxWidth: "1400px" }} spacing={8} alignItems="center">
                <Grid item xs={12} md={7}>
                    <Hello />
                </Grid>
                <Grid item xs={12} md={5}>
                    <Skills />
                </Grid>
            </Grid>
        </Stack>
    );
};
export default About;
